<template>
  <chart
    :width="width"
    :height="height"
    :chart-data="chartData"
    :options="options"
  />
</template>
<script>
import Chart from '@/components/charts/Chart'

export const availableFields = [
  {
    type: 'bar',
    label: '商品売上',
    unit: 'currency',
    fill: true,
    backgroundColor: '#023fa5',
    value: 'sales'
  },
  {
    type: 'bar',
    label: '自然売上',
    unit: 'currency',
    fill: true,
    backgroundColor: '#7d87b9',
    value: 'naturalSales'
  },
  {
    type: 'bar',
    label: '広告経由売上',
    unit: 'currency',
    fill: true,
    backgroundColor: '#bec1d4',
    value: 'adSales'
  },
  {
    type: 'line',
    label: '広告費',
    unit: 'currency',
    fill: false,
    backgroundColor: '#bb7784',
    value: 'adCost'
  },
  {
    type: 'line',
    label: 'クリック数',
    fill: false,
    backgroundColor: '#e07b91',
    value: 'clicks'
  },
  {
    type: 'line',
    label: 'コンバージョン数',
    fill: false,
    backgroundColor: '#d33f6a',
    value: 'conversions'
  },
  {
    type: 'line',
    label: 'CPC',
    unit: 'currency',
    fill: false,
    backgroundColor: '#11c638',
    value: 'cpc'
  },
  {
    type: 'line',
    label: 'CVR',
    unit: 'percentage',
    fill: false,
    backgroundColor: '#8dd593',
    value: 'cvr'
  },
  {
    type: 'line',
    label: 'セッション数',
    fill: false,
    backgroundColor: '#c6dec7',
    value: 'sessions'
  },
  {
    type: 'line',
    label: 'ページビュー数',
    fill: false,
    backgroundColor: '#ead3c6',
    value: 'pageviews'
  },
  {
    type: 'line',
    label: '広告ROAS',
    unit: 'percentage',
    fill: false,
    backgroundColor: '#f0b98d',
    value: 'adRoas'
  },
  {
    type: 'line',
    label: 'カートボックス獲得率',
    unit: 'percentage',
    fill: false,
    backgroundColor: '#0fcfc0',
    value: 'cartboxRate'
  },
  {
    type: 'line',
    label: '平均売価',
    unit: 'currency',
    fill: false,
    backgroundColor: '#9cded6',
    value: 'averageSales'
  },
  {
    type: 'line',
    label: '注文率',
    unit: 'percentage',
    fill: false,
    backgroundColor: '#f3e1eb',
    value: 'orderRate'
  },
  {
    type: 'line',
    label: 'カテゴリーSR',
    fill: false,
    backgroundColor: '#f6c4e1',
    value: 'categorySr'
  },
  {
    type: 'line',
    label: 'サブカテゴリーSR',
    fill: false,
    backgroundColor: '#f79cd4',
    value: 'subcategorySr'
  }
]

export default {
  name: 'AnalyticsChart',
  components: {
    Chart
  },
  props: {
    width: {
      type: Number,
      default: undefined
    },
    height: {
      type: Number,
      default: undefined
    },
    dataset: {
      type: Array,
      default: null
    },
    precision: { // 小数点第何位まで表示するか決める
      type: Number,
      default: 0
    },
    selectedLeftFields: {
      type: Array,
      default () {
        return []
      }
    },
    selectedRightFields: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    chartData () {
      let datasets = []
      const selectedFields = [this.selectedLeftFields, this.selectedRightFields]
      for (let i = 0; i < selectedFields.length; i++) {
        const yAxisID = i === 0 ? 'left' : 'right'
        for (const field of selectedFields[i]) {
          const {
            label,
            unit,
            fill,
            backgroundColor,
            type
          } = field
          const lineOption = (type === 'line') ? { tension: 0.4 } : {}

          let data = []
          if (unit === 'percentage') {
            data = this.dataset.map(item => {
              const base = 10 ** this.precision
              return Math.round((item[field.value] * 100) * base) / base
            })
          } else {
            data = this.dataset.map(item => item[field.value])
          }
          datasets = [
            ...datasets,
            {
              type,
              yAxisID,
              label,
              unit,
              fill,
              backgroundColor,
              borderColor: backgroundColor,
              pointBackgroundColor: backgroundColor,
              pointBorderColor: backgroundColor,
              data,
              ...lineOption
            }
          ]
        }
      }
      datasets.sort((a, b) => {
        if (a.type === 'line') {
          return -1
        }
        if (b.type === 'line') {
          return 1
        }
        return 0
      })
      return {
        labels: this.dataset.map(item => item.date),
        datasets
      }
    },
    options () {
      return {
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            mode: 'index',
            position: 'nearest',
            callbacks: {
              label (tooltipItem) {
                const label = tooltipItem.dataset.label
                const unit = tooltipItem.dataset.unit || ''
                const value = tooltipItem.formattedValue
                if (unit === 'currency') {
                  return `${label}: \xA5${value}`
                }
                if (unit === 'percentage') {
                  return `${label}: ${value}%`
                }
                return `${label}: ${value}`
              }
            }
          }
        },
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: false
          },
          right: {
            stacked: false,
            position: 'right',
            suggestedMin: 0,
            ticks: {
              callback (value) {
                return value.toLocaleString()
              }
            }
          },
          left: {
            stacked: false,
            suggestedMin: 0,
            ticks: {
              callback (value) {
                return value.toLocaleString()
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
